import { memo } from 'react';
import Highlighter from 'react-highlight-words';

import type { ValueDto } from '@/services/ws-search/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';

import { HoverWrapper, ItemWrapper } from './styles.ts';

type Props = {
  item: ValueDto;
  search: string;
  onClick: (id: ValueDto['id']) => void;
  highlightColor: string;
  dataTestId?: string;
};

export const SearchListItem = memo(function SearchListItem({ item, search, onClick, highlightColor, dataTestId }: Props) {
  const handleClick = useCallbackRef(() => {
    onClick(item.id);
  });

  return (
    <ItemWrapper $highlightColor={highlightColor} data-testid={dataTestId}>
      <HoverWrapper onClick={handleClick} role='button'>
        <Highlighter autoEscape searchWords={[search]} textToHighlight={item.name} />
      </HoverWrapper>
    </ItemWrapper>
  );
});
